type WindowOptions = {
  width?: number;
  height?: number;
};

type Options = WindowOptions & {
  onPostMessage: (event: MessageEvent) => unknown;
};

function getWindowFeatures(options?: WindowOptions) {
  const width = options?.width ?? 600;
  const height = options?.height ?? 600;
  const { screenLeft, screenTop, innerWidth, innerHeight, screen } = window;
  const html = window.document.documentElement;
  const dualScreenLeft = screenLeft !== undefined ? screenLeft : window.screenX;
  const dualScreenTop = screenTop !== undefined ? screenTop : window.screenY;
  const viewportWidth = innerWidth || html.clientWidth || screen.width;
  const viewportHeight = innerHeight || html.clientHeight || screen.height;

  const left = viewportWidth / 2 - width / 2 + dualScreenLeft;
  const top = viewportHeight / 2 - height / 2 + dualScreenTop;
  return `width=${width},height=${height},left=${left},top=${top}`;
}

export function openWindow(
  uri: string,
  { onPostMessage, ...options }: Options,
): Promise<void> {
  const win = window.open(uri, undefined, getWindowFeatures(options));

  let executor: null | { resolve: () => void } = null;

  const onResolve = () => {
    window.removeEventListener('message', onPostMessageWrapper);

    if (executor) {
      const currentExecutor = executor;
      win?.close();
      currentExecutor.resolve();
      executor = null;
    }
  };

  const onPostMessageWrapper = (event: MessageEvent) => {
    const result = onPostMessage(event);
    if (result) {
      onResolve();
    }
  };

  window.addEventListener('message', onPostMessageWrapper, true);

  return new Promise<void>(resolve => {
    executor = { resolve };
  });
}
